export default __webpack_public_path__ + "static/assets/4a629a4bb8007ae512b4cc92b3dca234.svg";